/**
 * Created by RKL on 07/09/2015.
 */
define('superAdminMbAnaResGrDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!superAdminMbAnaResGrDetailsTpl',
  'superAdminMbAnaResGrsTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  mbanaresgrsTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var MbAnaResGrsDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.mbanaresgr-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    events: {
      'click @ui.tab': 'onTabClick',
      'change @ui.collectionToggle': 'onCollectionToggle'
    },

    regions: {
      mbAnaResGrDetailTab: '#detail-tab',
      mbAnaResListTab: '#mbanares-tab'
    },

    behaviors: {
      BackToList: {
        behaviorClass: BackToListBehavior,
        redirectUrl: 'superAdmin/mbanaresgrs'
      }
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.mbAnaResGrsTabs = mbanaresgrsTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.mbanaresgr-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    },

    onTabClick: function(e) {
      var $target = $(e.currentTarget),
        tab = {
          route: $target.data('route'),
          role: $target.data('role'),
          name: $target.data('name')
        };

      this.ui.tab.removeClass('active');
      this.ui.tabPane.removeClass('active');
      $target.addClass('active');
      this.$('.tab-pane[data-name="' + tab.name + '"]').addClass('active');

      this.triggerMethod('click:tab', tab);
    },

    onHeaderChange: function(mbanaresgr) {
      this.ui.name.text(mbanaresgr.name);
      this.ui.code.text(mbanaresgr.code);
    }
  });

  module.exports = MbAnaResGrsDetailsView;
});
